/* gorilla-announcement-bar.js — Dismissible announcement bar */
(function () {
  'use strict';

  var BAR_KEY = 'gorilla-ann-dismissed';

  document.addEventListener('DOMContentLoaded', function () {
    var bar     = document.getElementById('gorilla-ann-bar');
    var dismiss = document.getElementById('gorilla-ann-dismiss');
    if (!bar) return;

    if (sessionStorage.getItem(BAR_KEY) === '1') {
      bar.style.display = 'none';
      return;
    }

    bar.style.display = '';

    if (dismiss) {
      dismiss.addEventListener('click', function () {
        bar.style.display = 'none';
        sessionStorage.setItem(BAR_KEY, '1');
      });
    }
  });
})();
